<template>
  <header class="login__header">
    <div class=" d-flex align-center" :class="isWaitingList ? 'container-fluid px-4' : 'container'">
      <img class="logo__tn" src="@/assets/logo_mini.svg" alt @click="$router.push('/')" />
      <div class="flex-grow-1"></div>
      <img class="logo__transtan" src="@/assets/logo.png" alt />
    </div>
  </header>
</template>
<script>
export default {
  computed: {
        isWaitingList() {
      return this.$route.name == "commong-waiting-list";
    },

  }
}
</script>
<style lang="scss">
.login {
  &__header {
    background: white;
    height: 70px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    .container, .container-fluid {
      height: 70px;
      align-items: center;
    }
    .logo__tn {
      height: 45px;
      width: 45px;
      cursor: pointer;
    }
    .logo__transtan {
      width: 60px;
      height: 45px;
    }
  }
}
</style>
